import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as termsAndConditionsState from '../auth.reducer';
import * as termsAndConditionsReducer from '../reducers/get-terms-and-conditions.reducer';

export const getTermsAndConditions = createSelector(
  termsAndConditionsState.getTermsAndConditionsState,
  termsAndConditionsReducer.getTermsAndConditionsResponse
);

export const getTermsAndConditionsLoaded = createSelector(
  termsAndConditionsState.getTermsAndConditionsState,
  termsAndConditionsReducer.getTermsAndConditionsLoaded
);
